import { USER_LEVEL } from 'constants/global';
import { STEPS } from 'constants/registration';

export const REGISTRATION_MODE = {
  NEW_REGISTRATION: 'NEW_REGISTRATION',
  LEGACY_INCOMPLETE_RESUME: 'LEGACY_INCOMPLETE_RESUME',
};

/** Pasos del cierre robusto. El alta nueva no usa esta lista. */
export const LEGACY_RESUME_STEPS = [
  STEPS.IDENTITY_VALIDATION,
  STEPS.IDENTITY_RESUME,
  STEPS.ADDRESS,
  STEPS.SUCCESS_COMPLETE,
];

/**
 * Cuenta ya autenticada y sin nivel COMPLETE, en la app nativa.
 * No incluye el alta anónima ni a un usuario COMPLETE.
 * @param {{ userId?: string, userLevel?: string, legacyResumeEnabled?: boolean }} state
 * @returns {string}
 */
export function resolveRegistrationMode({
  userId,
  userLevel,
  legacyResumeEnabled = false,
} = {}) {
  if (legacyResumeEnabled && userId && userLevel !== USER_LEVEL.COMPLETE) {
    return REGISTRATION_MODE.LEGACY_INCOMPLETE_RESUME;
  }
  return REGISTRATION_MODE.NEW_REGISTRATION;
}

export const NEW_CLIENT_AUTH_STEP = {
  COMPLETE_SIGNUP: 'complete-signup',
  SAVE_PASSWORD: 'save-password',
  SIGN_IN: 'sign-in',
};

export const REGISTRATION_REFRESH = {
  STAY: 'stay',
  USE_EMAIL_PASSWORD_LINK: 'use-email-password-link',
  RESTART_AND_RECOVER_PASSWORD: 'restart-and-recover-password',
};

export const ID_MISSION_LOG_TIMING = {
  AFTER_CAPTURE: 'after-capture',
  AFTER_AUTH: 'after-auth',
};

/**
 * /idmission/log sigue ejecutándose después del login.
 * Cuando Backend confirme que el endpoint ya es público, cambiar a AFTER_CAPTURE.
 */
export const ID_MISSION_LOG_TIMING_ACTIVE = ID_MISSION_LOG_TIMING.AFTER_AUTH;

export function getIdMissionLogTiming() {
  return ID_MISSION_LOG_TIMING_ACTIVE;
}

/**
 * Después de un /signup/complete exitoso, el token solo sirve para
 * POST /users/password. El sign-in usa correo y contraseña, y no
 * vuelve a crear la cuenta ni a repetir la contraseña ya guardada.
 * @param {{ signupAuth?: { id?: string, token?: string }, passwordSaved?: boolean }} state
 */
export function resolveNewClientAuthStep({ signupAuth, passwordSaved = false } = {}) {
  if (signupAuth?.id && signupAuth?.token) {
    if (passwordSaved) {
      return {
        step: NEW_CLIENT_AUTH_STEP.SIGN_IN,
        token: signupAuth.token,
        userId: signupAuth.id,
        callsComplete: false,
      };
    }
    return {
      step: NEW_CLIENT_AUTH_STEP.SAVE_PASSWORD,
      token: signupAuth.token,
      userId: signupAuth.id,
      callsComplete: false,
    };
  }
  return {
    step: NEW_CLIENT_AUTH_STEP.COMPLETE_SIGNUP,
    callsComplete: true,
  };
}

/**
 * El token del alta solo vive en memoria. Si un refresh lo pierde,
 * la recuperación es el flujo ya existente de contraseña.
 */
export function resolveRegistrationRefresh({
  isKnownStep = false,
  isStart = false,
  hasPhoneInMemory = false,
  hasEmailPasswordToken = false,
} = {}) {
  if (isKnownStep && (isStart || hasPhoneInMemory)) {
    return REGISTRATION_REFRESH.STAY;
  }
  if (hasEmailPasswordToken) {
    return REGISTRATION_REFRESH.USE_EMAIL_PASSWORD_LINK;
  }
  return REGISTRATION_REFRESH.RESTART_AND_RECOVER_PASSWORD;
}
